import { useState } from 'react';
import { SetState } from '../types/set-state';

type ReturnT = {
    showModal: boolean;
    setShowModal: SetState<boolean>;
    pending: boolean;
    setPending: SetState<boolean>;
    onSubmit: () => void;
    onClick: () => void;
    onHideModal: () => void;
};

const useShowPopup = (onSubmitCallback: () => void, onHideCallback?: () => void): ReturnT => {
    const [showModal, setShowModal] = useState(false);
    const [pending, setPending] = useState(false);

    const onSubmit = () => {
        if (pending) {
            return;
        }

        setPending(true);

        onSubmitCallback && onSubmitCallback();
    };

    const onClick = () => {
        setShowModal(true);
    };

    const onHideModal = () => {
        if (onHideCallback) {
            onHideCallback();
        } else {
            setShowModal(false);
        }
    };

    return { showModal, setShowModal, pending, setPending, onSubmit, onClick, onHideModal };
};

export default useShowPopup;
